export const decorationPrice = (placement, method, pricing, printing) => {
  if (method === 'printing') return Number(printing?.[String(placement.size)] ?? printing?.[String(Math.ceil(placement.size))] ?? 0);
  const bands = (pricing.ranges || []).filter(b => b.complexity === placement.complexity
    && b.min <= placement.size && placement.size <= b.max);
  if (bands.length > 1) return 0;
  const exact = bands.length ? bands[0].price : pricing[placement.complexity]?.[String(placement.size)];
  if (exact != null) return Number(exact);
  if (Number.isFinite(Number(placement.size)) && placement.size !== Math.ceil(placement.size)) {
    return decorationPrice({ ...placement, size: Math.ceil(placement.size) }, method, pricing, printing);
  }
  return 0;
};

export const placementSizeLabel = placement => placement.size_range || placement.size;

export const placementOptions = (location, method, complexity) =>
  location?.size_options?.[method === 'printing' ? 'printing' : complexity] || [];

export const placementSupportsSize = (location, method, complexity, size) => {
  const bounds = String(location?.size_range || '').match(/^\s*(\d+(?:\.\d+)?)\s*(?:[-–]\s*(\d+(?:\.\d+)?))?\s*$/);
  if (bounds && !(Number(bounds[1]) <= size && size <= Number(bounds[2] || bounds[1]))) return false;
  return placementOptions(location, method, complexity).some(o =>
    (o.min <= size && size <= o.max) || (o.min <= Math.ceil(size) && Math.ceil(size) <= o.max));
};
